import Vue from "vue";

Vue.directive('update-sidenav-selection', {

    params: ['categoryId'],

    bind(el){ },

    update(el, binding) {

        for (const breadcrumb of binding.value) {
            if (breadcrumb.id === parseInt(el.dataset.categoryId)) {
                el.classList.add('sidebar__list-item--active');
                break;
            } else {
                el.classList.remove('sidebar__list-item--active');
            }
        }
    }
});
